var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cData)?_c('div',{staticClass:"h-ts-e-button h-ts-e-button-click-color",attrs:{"type":"button"},on:{"click":_vm.queryCalledDetail}},[_c('span',[_vm._v(_vm._s(_vm.$ts('TS.ts_call_detail')))])]):_c('div',{staticClass:"h-ts-e-button h-ts-e-button-no-click-color",attrs:{"type":"button"}},[_c('span',[_vm._v(_vm._s(_vm.$ts('TS.ts_call_detail')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }